import { UtmTypes } from "redux/reducers/general/utm";

export const POST_SAVE_UTM = "POST_SAVE_UTM";

export const postSaveUTM = (dataUTM?: UtmTypes) => ({
  dataUTM,
  type: POST_SAVE_UTM,
});
